exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image{background-size:cover;cursor:pointer;border-radius:3px;border:1px solid #d3d3d3;-o-object-fit:contain;object-fit:contain}.vgs__container{height:80vh!important;background-color:transparent!important}.vgs__container,.vgs__gallery{left:0!important;right:0!important}.vgs__gallery{bottom:-30px!important}.vgs__gallery__container__img{width:80px!important;height:50px!important;margin-right:5px!important;border-radius:2px!important}", ""]);

// exports
